import { Skeleton } from '../../../../feedback/Skeleton';
import { Box } from '../../../../layout/Box';
import { Column, DateColumn, Row } from '../../styles';

export const ContentPromotionPostsDialogSkeleton: React.FC<{}> = () => (
    <Row>
        <Column alignItems="center">
            <Skeleton variant="rect" width={24} height={24} borderRadius={1} />
        </Column>
        <Skeleton variant="rect" width={64} height={64} borderRadius={1} />
        <Column flexGrow={1} alignItems="flex-start">
            <Box width="100%">
                <Skeleton variant="text" width="100%" height={14} />
                <Skeleton variant="text" width="80%" height={14} />
            </Box>
            <Skeleton variant="text" width={100} height={14} />
        </Column>
        <DateColumn justifySelf="end" justifyContent="flex-end">
            <Skeleton variant="text" width="80%" height={14} />
        </DateColumn>
    </Row>
);
